import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

const Footer = () => {
  const { user } = useContext(AuthContext);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t-4 border-slate-900">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Brand */}
        <div className="mb-6">
          <h3 className="text-lg font-bold bg-gradient-to-r from-teal-600 via-purple-600 to-magenta-600 bg-clip-text text-transparent mb-2">BoardRez</h3>
          <p className="text-sm text-slate-600">
            Reserve your training time on climbing boards. Built for the climbing community.
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap gap-x-6 gap-y-2 mb-6">
          <a href="/dashboard" className="text-sm text-slate-600 hover:text-teal-600 font-medium transition-colors">
            Dashboard
          </a>
          {/* Only show "My Reservations" for gym members (not admin, gym_manager, platform_admin, or chain_owner) */}
          {!['admin', 'gym_manager', 'platform_admin', 'chain_owner'].includes(user?.role) && (
            <a href="/reservations" className="text-sm text-slate-600 hover:text-teal-600 font-medium transition-colors">
              My Reservations
            </a>
          )}
          <a href="/contact" className="text-sm text-slate-600 hover:text-teal-600 font-medium transition-colors">
            Contact Us
          </a>
          <a href="/privacy" className="text-sm text-slate-600 hover:text-teal-600 font-medium transition-colors">
            Privacy Policy
          </a>
          <a href="/terms" className="text-sm text-slate-600 hover:text-teal-600 font-medium transition-colors">
            Terms of Service
          </a>
        </div>

        {/* Bottom bar */}
        <div className="border-t-2 border-slate-200 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-sm text-slate-600 font-medium">
              © {currentYear} BoardRez, LLC. All rights reserved.
            </p>
            <p className="text-sm bg-gradient-to-r from-teal-600 via-purple-600 to-magenta-600 bg-clip-text text-transparent font-semibold">
              Built with ❤️ for the climbing community
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;